import { useState } from 'react';
import { AxiosResponse } from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { saveAs } from 'file-saver';

import { getReports, setReportsAction, clearReportsAction } from 'features/reports/redux/slice';

import { UseReportsState, AnalysisReportApiResponse } from './types';
import { request } from 'app/utils';
import { useSchool } from 'features/school';

const useReport = (): UseReportsState => {
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadPercentage, setDownloadPercentage] = useState(0);

  const { apiGatewayUrl } = useSchool();

  const dispatch = useDispatch();

  const reports = useSelector(getReports);

  const setReports = (reports: AnalysisReportApiResponse) => {
    dispatch(setReportsAction(reports));
  };

  const clearReports = () => {
    dispatch(clearReportsAction());
  };

  const downloadReport = (downloadUrl: string, downloadFileName: string) => {
    setDownloadLoading(true);

    request({
      url: `/api/v1/School/AnalysisReport/Download/${downloadUrl}`,
      method: 'get',
      baseURL: apiGatewayUrl,
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        let percentCompleted = (total===undefined) ? 0 :  Math.floor((loaded / total) * 100);

        setDownloadPercentage(percentCompleted);
      },
    })
      .then((response: AxiosResponse<Blob>) => {
        saveAs(response.data, downloadFileName);
        setTimeout(() => {
          setDownloadPercentage(0);
        }, 0);
      })
      .catch((error) => {
        setDownloadPercentage(0);
      })
      .finally(() => {
        setDownloadLoading(false);
      });
  };

  return {
    ...reports,
    setReports,
    clearReports,
    downloadLoading,
    downloadPercentage,
    downloadReport,
  };
};

export default useReport;
